import React, { FunctionComponent } from 'react';
import { Grid, Paper, Box, Typography } from '@mui/material';
import DashboardLayout from '../../components/layout/layout';
import InventoryIcon from "@mui/icons-material/Inventory2";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
// import AnalyticsIcon from "@mui/icons-material/Analytics";
import { useNavigate, Navigate } from 'react-router-dom';
import StorageService from '../../services/storageService'


// const data = [
//   { name: "Total Inventory", value: 45, color: "#d01e42" },
//   { name: "Best Sales", value: 30, color: "#e85c78" },
//   { name: "Order Request", value: 25, color: "#f48ca0" },
//   { name: "Order Completed", value: 10, color: "#f8cdd4" },
// ];

const data = [
  { 
    name: "Price/leadTime/inventory",
    icon: <InventoryIcon sx={{ fontSize: 28, color: '#1976d2' }} />
  },
  { 
    name: "Order Entry",
    icon: <TrendingUpIcon sx={{ fontSize: 28, color: '#2e7d32' }} />
  },
  { 
    name: "Order Status / invoices",
    icon: <RequestPageIcon sx={{ fontSize: 28, color: '#ed6c02' }} />
  },
  { 
    name: "Sales Tools",
    icon: <AssignmentTurnedInIcon sx={{ fontSize: 28, color: '#9c27b0' }} />
  },
  // { 
  //   name: "Analytics & Insights",
  //   icon: <AnalyticsIcon sx={{ fontSize: 28, color: '#d32f2f' }} />,
  //   isAnalytics: true
  // },
];



const Dashboard: FunctionComponent = () => {
  const selectedExtranet = StorageService.getSelectedExtranet();
  const navigate = useNavigate();
  const userInfo = StorageService.getUserInfo();

  // Redirect Barksdale Admin extranet users to the dedicated home page
  if (selectedExtranet === 'Barksdale Admin') {
    return <Navigate to="/barksdale-admin" replace />;
  }
  const handleItemClick = (itemName: string) => {
    switch(itemName) {
      case "Price/leadTime/inventory":
        navigate('/inventory'); // or your inventory route
        break;
      case "Order Entry":
        if (userInfo?.accessLevel === 'Barksdale'){
          navigate('/order-management-system/online-order-entry')
        }else{
        navigate('/order-management-system/online-order-entry/header'); // or your order entry route
        }
        break;
      case "Order Status / invoices":
        navigate('/order-management-system/check-order-status'); // or your order status route
        break;
      case "Sales Tools":
        navigate('/resources'); // or your sales tools route
        break;
      // case "Analytics & Insights":
      //   navigate('/analytics');
      //   break;
      default:
        break;
    }
  };
  
  return (
    <>
      <DashboardLayout isLoading={false} title={"Welcome To Barksdale Extranet"} initialBreadcrumbs={"Channel Partners"} levelBreadcrumbs={""} breadcrumbs={'Extranet'} activeMenu={'overview'} container={true}>
        <Box sx={{alignItems: "center", justifyContent: "space-between"}}>
          <Grid container spacing={2} sx={{ maxWidth: "100%" }}>
            {data.map((item) => (
              <Grid size={6} key={item.name}>
                <Paper
                  variant="outlined"
                  sx={{ 
                    p: 2, 
                    flexDirection: 'column', 
                    gap: 2, 
                    borderRadius: 0, 
                    height: { xs: '80px', sm: '100px', md: '120px' }, 
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }
                  }}
                  onClick={() => handleItemClick(item.name)}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, height: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: 40 }}>
                      {item.icon}
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography fontWeight="bold" variant="body1">
                        {item.name}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
          
          {/* <PieChart width={200} height={200}>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={70}
              innerRadius={30}
            >
              {data.map((entry, index) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>
          </PieChart> */}
        </Box>
      </DashboardLayout>
    </>
  );
};

export default Dashboard;